<template>
    <section class="mt-3 balance-payment-types">
        <PaymentMethod class="mt-4" :form="form" :auth_role="auth_role" :days="days" :has_shipping="has_shipping"
            :shipping_method_id="shipping_method_id" :banks="banks" :payment_intents="payment_intents" :cards="cards"
            :wholesale="true" :formBank="formBank" :link_token="link_token"
            :mtd_instant_payment_only="$page.props.auth.user.mtd_instant_payment_only" :isCheckout="true"
            bankRoute="cart.addBank" @setPaymentMethod="setPaymentMethod" @selectTerm="selectTerm"
            @setPaymentIntent="setPaymentIntent" @bankAdded="bankAdded" :paymentBalance="user.account_balance"
            :current_account_balance="user.account_balance" />
    </section>
</template>

<script>
import PaymentMethod from '@/Components/Shop/PaymentMethod'

export default {
    components: {
        PaymentMethod,
    },
    data() {
        return {
            formCash: this.$inertia.form({
                amount: null
            }),
        }
    },
    props: {
        form: Object,
        for_user: Object,
        user: Object,
        payment_intents: Array,
        cards: Array,
        banks: Array,
        link_token: String,
        form_bank: Object,
    },
    methods: {
        setPaymentIntent(paymentIntent) {
            this.form.payment_intent = paymentIntent;
            this.form.stripe_payment_method = null;
            this.$emit('setPaymentIntent', paymentIntent)
        },
        setPaymentMethod(e, id) {
            this.$emit('setPaymentMethod', e, id)
        },
        bankAdded() {
            this.$emit('bankAdded')
        },
        cashOpen() {
            this.formCash.post(this.route('mtd.cash.open'))
        },
        calcCashChange() {
            this.form.payment_intent = 'Cash'

            let amount = this.form.payment_amount

            if (parseFloat(this.form.cash_credit_amount) >= parseFloat(amount)) {
                this.form.cash_debit_amount = this.form.cash_credit_amount - amount
            } else this.form.cash_debit_amount = null
        },
    }
}
</script>

<style>
.balance-payment-types .nav-tabs .nav-item {
    flex-grow: 1;
    text-align: center;
}
</style>
